/**
 * @license
 * @preserve
 *
 * KeeeX SAS Confidential
 * https://keeex.me
 * Copyright 2013-2023 KeeeX All Rights Reserved.
 * 
 * These computer program listings and specifications, herein,
 * are and remain the property of KeeeX SAS. The intellectual
 * and technical concepts herein are proprietary to KeeeX SAS
 * and may be covered by EU and foreign patents,
 * patents in process, trade secrets and copyright law.
 * 
 * They shall not be reproduced or copied or used in whole or
 * in part as the basis for manufacture or sale of items unless
 * prior written permission is obtained from KeeeX SAS.
 * 
 * For a license agreement, please contact:
 * <mailto: contact@keeex.net>
 * 
 */
export const getBitcoinKeypair=async()=>{const{default:t}=await import("./bitcoin/keypair.js");return t};export const getBitcoinDataFilter=async()=>{const{isBitcoinImportData:t}=await import("./bitcoin/iotypes.js");return t};export const getEthereumKeypair=async()=>{const{default:t}=await import("./ethereum/keypair.js");return t};export const getEthereumDataFilter=async()=>{const{isEthereumImportData:t}=await import("./ethereum/iotypes.js");return t};export const getX509Keypair=async()=>{const{default:t}=await import("./x509/keypair.js");return t};export const getX509DataFilter=async()=>{const{isImportData:t}=await import("./x509/iotypes.js");return t};